"use client";

import React, { useState, useEffect } from "react";
import { Menu } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "@/components/ui/sheet";
function DesktopMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div data-section-id="205414" className="hidden md:flex gap-6">
        {}
      </div>;
  }
  return <NavigationMenu viewport={false} className="hidden md:flex">
      <NavigationMenuList className="gap-8">
        {}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenu({
  setOpen
}: {
  setOpen: (open: boolean) => void;
}) {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-6 mt-12 px-4">
        {}
      </div>;
  }
  return <div className="flex flex-col gap-6 mt-12 px-4">
      {}
    </div>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest('a[href]') as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute('href');
        if (!href) return;
        if (href === '/#') {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          return;
        }
        let hash = '';
        if (href.startsWith('#')) {
          hash = href;
        } else if (href.startsWith('/') && href.includes('#')) {
          const [path, hashPart] = href.split('#');
          if (hashPart === '') {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            return;
          }
          if (path === '/' || path === window.location.pathname) {
            hash = '#' + hashPart;
          }
        }
        if (hash && hash !== '#') {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
            setMobileMenuOpen(false);
          }
        }
      }
    };
    document.addEventListener('click', handleAnchorClick);
    return () => document.removeEventListener('click', handleAnchorClick);
  }, []);
  return <section id="header" className={`dark bg-background text-foreground sticky top-0 z-50 w-full transition-all duration-500 ${isScrolled ? "bg-background/80 backdrop-blur-lg border-b border-border/50 shadow-sm shadow-primary/5" : "bg-background border-b border-transparent"}`}>
      <div className="w-full mx-auto px-4 md:px-6 h-20 flex items-center justify-between">
        {}
        <Link to="/" className="flex items-center z-50 relative group">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1633370/img/image_unosbtxi.png" alt="Tidal Swing AI" className="h-7 w-auto transition-transform duration-500 group-hover:scale-105" />
        </Link>

        {}
        <div className="absolute left-1/2 -translate-x-1/2">
          <MenuProvider menu_id="50">
            <DesktopMenu />
          </MenuProvider>
        </div>

        {}
        <div className="flex items-center gap-4 z-50">
          <Link to="#" className="hidden md:block transition-transform duration-300 hover:scale-105 active:scale-95">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1633370/img/image_og9y0m3d.webp" alt="Initiate Partnership" className="h-9 w-auto" />
          </Link>

          {}
          <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="md:hidden text-foreground hover:bg-muted/50 hover:text-primary transition-colors">
                <Menu className="h-6 w-6" />
                <span className="sr-only">Toggle menu</span>
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="dark bg-background/95 backdrop-blur-xl text-foreground inset-0 w-full h-full p-0 flex flex-col border-none">
              <SheetTitle className="sr-only">Navigation Menu</SheetTitle>
              
              <div className="flex-1 overflow-y-auto py-8">
                <MenuProvider menu_id="50">
                  <MobileMenu setOpen={setMobileMenuOpen} />
                </MenuProvider>
              </div>

              <div className="p-6 border-t border-border/30 bg-background/50 flex justify-center">
                <Link to="#" onClick={() => setMobileMenuOpen(false)} className="transition-transform duration-300 active:scale-95">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1633370/img/image_og9y0m3d.webp" alt="Initiate Partnership" className="h-12 w-auto" />
                </Link>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </section>;
}